import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { getCementoRegionCode } from 'src/app/shared/utils/cemento-region-code';
import { environment } from 'src/environments/environment';

export interface CementoCoverageResponse {
  hasCoverage: boolean;
  incoterms: string[];
}

@Injectable({ providedIn: 'root' })
export class CementoCoverageService {
  private readonly baseUrl = `${environment.apiUrl}cemento/politica/`;
  constructor(private readonly http: HttpClient) {}

  getCoverage(region: number | string, comuna: string): Observable<CementoCoverageResponse> {
    const regionCode = typeof region === 'number' ? region : getCementoRegionCode(region);
    const comunaNombre = comuna.trim();

    if (regionCode == null) {
      return throwError(() => new Error('No pudimos identificar la región seleccionada.'));
    }

    const comunaEncoded = encodeURIComponent(comunaNombre);
    console.log('[CementoCoverage] GET', `${this.baseUrl}coverage/${regionCode}/${comunaEncoded}/`);
    return this.http.get<CementoCoverageResponse>(
      `${this.baseUrl}coverage/${regionCode}/${comunaEncoded}/`
    );
  }
}
